module.exports = __webpack_public_path__ + "r-v3/img/controls_white.93bc6a8e.svg";